<template>
    <div class="flex flex-col flex-1 min-h-full" style="--sidebar-width: 240px">
        <header class="sticky shrink-0 top-0 z-50 h-16 px-4 flex items-center bg-primary border-b border-secondary">
            <slot name="header" />
        </header>
        <div class="flex flex-1 min-h-full">
            <slot />
        </div>
    </div>
</template>

<script setup lang="ts">
</script>
